import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FeatureFlagService } from '../../../services';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-account-intent-container',
    template: `
		<div class="nav-detail flex flex-col h-full" *ngIf="(flagsInitialized$ | async); else loader">
            <app-account-intent
                class="flex flex-col h-full"
                [saveIntentEvent]="saveIntentEvent"
                [activeTab]="activeTab"
                [isLoading]="isLoading"
                (tabChange)="tabChange.emit($event)"
                (dataSaved)="dataSaved.emit()"
            ></app-account-intent>
        </div>

		<ng-template #loader>
			<div class="h-full flex justify-center items-center text-primary-light">
				<mat-spinner></mat-spinner>
			</div>
		</ng-template>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountIntentContainerComponent {
    @Input() saveIntentEvent: symbol;
    @Input() activeTab: number;
    @Input() isLoading: boolean;
    @Output() tabChange: EventEmitter<any> = new EventEmitter();
    @Output() dataSaved: EventEmitter<void> = new EventEmitter<void>();

    flagsInitialized$: Observable<boolean>;

    constructor(private readonly featureFlagService: FeatureFlagService) {
        this.flagsInitialized$ = this.featureFlagService.areFlagsInitialized();
    }
}
